import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';
import { ROUTES } from '@/config/routes';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import ChatsList from './components/ChatsList/ChatsList';
import { useMyChats } from '@/queries/chats';

export const ChatsPage = () => {
  const navigate = useNavigate();
  const { chatId } = useParams();
  const { isMobile } = useBreakpoints();
  const { data: chats = [] } = useMyChats();

  useEffect(() => {
    if (!chats.length || isMobile || chatId) return;

    navigate(ROUTES.CHATS.BY_ID(chats[0].id));
  }, [chats, isMobile, chatId, navigate]);

  return (
    // header height is 64px
    <div className="h-[calc(100vh-64px)] grow overflow-hidden">
      <div
        className={cn(
          'flex h-full transition-transform duration-300 ease-out will-change-transform',
          'max-md:w-[200%]',
          chatId ? 'max-md:-translate-x-1/2' : 'max-md:translate-x-0',
          'md:w-full md:translate-x-0',
        )}
      >
        <aside className="h-full w-1/2 shrink-0 md:w-[300px] md:border-r md:border-lightGray xl:w-[320px]">
          <ChatsList chats={chats} />
        </aside>
        <section className="h-full w-1/2 min-w-0 grow overflow-hidden md:w-auto">
          <Outlet />
        </section>
      </div>
    </div>
  );
};
